import { render } from "./TokenExplorer.vue?vue&type=template&id=0a6b1cfd&scoped=true"
import script from "./TokenExplorer.vue?vue&type=script&setup=true&lang=js"
export * from "./TokenExplorer.vue?vue&type=script&setup=true&lang=js"

import "./TokenExplorer.vue?vue&type=style&index=0&id=0a6b1cfd&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a6b1cfd"],['__file',"resources/js/components/TokenExplorer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0a6b1cfd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0a6b1cfd', __exports__)) {
    api.reload('0a6b1cfd', __exports__)
  }
  
  module.hot.accept("./TokenExplorer.vue?vue&type=template&id=0a6b1cfd&scoped=true", () => {
    api.rerender('0a6b1cfd', render)
  })

}


export default __exports__